import { render } from "./FormPhotoFireExtinguisher.vue?vue&type=template&id=68302864"
import script from "./FormPhotoFireExtinguisher.vue?vue&type=script&lang=js"
export * from "./FormPhotoFireExtinguisher.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__